enum modalType {
    CLOSED = 'CLOSED',
    ADD = 'ADD',
    EDIT = 'EDIT',
    DELETE = 'DELETE'
}

export default modalType;
